/**
 * Einstellungsschlüssel in der Maske (AP-22-B, seit Teil 6 aus dem Rechenkern).
 *
 * **Welche** Schlüssel es gibt, steht im Einstellungskatalog von
 * `@symphenia/payroll-core` — dort lesen ihn auch der Server und die KV-Vorlagen. Hier
 * bleibt nur die Übersetzung zwischen dem Text aus `payroll_settings` und dem Wert im Feld.
 *
 * **Der Vorgabewert steht in der KV-Vorlage**, nicht hier: Was die Maske als Standard zeigt,
 * ist `vorlageWerte(vorlage, stichtag)` — genau das, womit der Monat ohne eigenen Satz rechnet.
 */
import { EINSTELLUNGSKATALOG, einstellungDef, type EinstellungArt, type EinstellungDef } from '@symphenia/payroll-core';

/** Wie der Wert in der Maske erscheint; gespeichert wird er immer als Text. */
export type SettingArt = EinstellungArt;
export type SettingKeyDef = EinstellungDef;

export const SETTING_KEY_CATALOG: readonly SettingKeyDef[] = EINSTELLUNGSKATALOG;

/** Beschriftung eines Schlüssels; unbekannte Schlüssel behalten ihren Namen. */
export function labelForKey(key: string): string {
  return einstellungDef(key)?.label ?? key;
}

export function artFuer(key: string): SettingArt | undefined {
  return einstellungDef(key)?.art;
}

/** Text aus `payroll_settings` → Wert in der Maske. */
export function alsWert(key: string, text: string | undefined): unknown {
  if (text === undefined) return null;
  switch (artFuer(key)) {
    case 'zahl': {
      const n = Number(text.replace(',', '.'));
      return Number.isFinite(n) ? n : null;
    }
    case 'schalter':
      return text === '1' || text.toLowerCase() === 'true';
    default:
      return text;
  }
}

/** Wert aus der Maske → Text für `payroll_settings`; `null` = kein eigener Wert. */
export function alsText(key: string, wert: unknown): string | null {
  if (wert === null || wert === undefined) return null;
  if (artFuer(key) === 'schalter') return wert ? '1' : '0';
  const t = String(wert).trim();
  return t === '' ? null : t;
}
